var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVacationCountIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "travel-places-mountain--sun-landmark-mountain-place"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9286 19.8428L20.8071 9.12854C20.6079 8.9277 20.3709 8.76828 20.1098 8.65949C19.8487 8.5507 19.5686 8.49469 19.2857 8.49469C19.0028 8.49469 18.7227 8.5507 18.4616 8.65949C18.2005 8.76828 17.9635 8.9277 17.7643 9.12854L1.07143 28.9285H28.9286",
    stroke: "#169A52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.05 18.2143L13.2 20.3572C13.5629 20.6155 13.9974 20.7544 14.4429 20.7544C14.8884 20.7544 15.3228 20.6155 15.6857 20.3572L17.5929 18.9214C17.9638 18.6432 18.4149 18.4929 18.8786 18.4929C19.3422 18.4929 19.7934 18.6432 20.1643 18.9214L22.0714 20.3572C22.4323 20.6107 22.8625 20.7468 23.3036 20.7468C23.7446 20.7468 24.1749 20.6107 24.5357 20.3572L27.7071 18.2143",
    stroke: "#169A52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.42857 11.7857C9.38724 11.7857 11.7857 9.38722 11.7857 6.42855C11.7857 3.46989 9.38724 1.07141 6.42857 1.07141C3.4699 1.07141 1.07143 3.46989 1.07143 6.42855C1.07143 9.38722 3.4699 11.7857 6.42857 11.7857Z",
    stroke: "#169A52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 10,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVacationCountIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vacation_count_icon.4dabb91ff2383144431cf9d1d400164f.svg";